var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "pagarme-icon",
      attrs: {
        width: "120",
        height: "32",
        viewBox: "0 0 120 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c(
        "mask",
        {
          attrs: {
            id: "mask0",
            "mask-type": "alpha",
            maskUnits: "userSpaceOnUse",
            x: "99",
            y: "0",
            width: "21",
            height: "22",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M99.3467 0H120V21.5739H99.3467V0Z",
              fill: "white",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask0)" } }, [
        _c("path", {
          attrs: {
            id: "pgm-logo",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M113.156 21.5739H119.979C119.99 21.2938 120 21.0137 120 20.7307C120 9.30731 110.737 0.0130635 99.3467 -0.000411987V6.83311C106.99 6.83792 113.185 13.066 113.185 20.7312C113.185 21.0141 113.173 21.2947 113.156 21.5739Z",
            fill: "#30A46C",
          },
        }),
      ]),
      _c(
        "mask",
        {
          attrs: {
            id: "mask1",
            "mask-type": "alpha",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "14",
            width: "14",
            height: "18",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M0 14.0793H13.1198V31.6846H0V14.0793Z",
              fill: "white",
            },
          }),
        ]
      ),
      _c("g", { attrs: { mask: "url(#mask1)" } }, [
        _c("path", {
          attrs: {
            id: "pgm",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M9.36236 17.5729C8.65964 16.7855 7.72988 16.3918 6.57212 16.3918C5.38172 16.3918 4.42268 16.7812 3.69548 17.5603C2.9678 18.3395 2.60396 19.3507 2.60396 20.5943C2.60396 21.8874 2.9678 22.9067 3.69548 23.6527C4.42268 24.3987 5.40668 24.7717 6.64652 24.7717C7.8038 24.7717 8.72156 24.3862 9.39932 23.6157C10.0776 22.8447 10.4164 21.8456 10.4164 20.6193C10.4164 19.3757 10.0651 18.3602 9.36236 17.5729ZM-5.34058e-05 14.3277H2.67835V15.9938C2.71147 15.9443 2.76523 15.874 2.83963 15.7826C2.91403 15.6916 3.07963 15.5381 3.33547 15.3225C3.59227 15.1069 3.87307 14.9163 4.17883 14.7507C4.48459 14.5852 4.89835 14.4316 5.41915 14.2906C5.93995 14.1496 6.48139 14.0793 7.04347 14.0793C8.82907 14.0793 10.2883 14.6718 11.4211 15.8571C12.5534 17.0425 13.1198 18.6052 13.1198 20.5442C13.1198 22.5833 12.5534 24.1831 11.4211 25.3434C10.2883 26.5042 8.79595 27.0842 6.94411 27.0842C6.38203 27.0842 5.85307 27.0178 5.35675 26.8854C4.86091 26.7526 4.45579 26.5913 4.14187 26.4003C3.82747 26.2097 3.55483 26.0235 3.32299 25.8411C3.09211 25.6587 2.92651 25.5013 2.82715 25.3684L2.67835 25.1697V31.6846H-5.34058e-05V14.3277Z",
          },
        }),
      ]),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M18.6101 23.6031C19.3128 24.3822 20.2426 24.7716 21.3999 24.7716C22.6234 24.7716 23.5949 24.3986 24.3144 23.6531C25.0335 22.9067 25.393 21.8873 25.393 20.5942C25.393 19.3511 25.021 18.3481 24.277 17.5853C23.533 16.823 22.5658 16.4418 21.3754 16.4418C20.2013 16.4418 19.2711 16.823 18.5851 17.5853C17.8992 18.3481 17.556 19.3511 17.556 20.5942C17.556 21.8209 17.9074 22.8239 18.6101 23.6031ZM27.997 26.8853H25.3186V25.1696C25.2855 25.2192 25.236 25.2899 25.1698 25.3809C25.1035 25.4723 24.9466 25.6254 24.6989 25.841C24.4507 26.0566 24.1819 26.2472 23.8925 26.4127C23.6031 26.5787 23.2066 26.7318 22.7021 26.8728C22.1981 27.0138 21.6648 27.0841 21.1023 27.0841C19.2835 27.0841 17.7917 26.5292 16.6258 25.4179C15.4603 24.3076 14.8776 22.7161 14.8776 20.6442C14.8776 18.6879 15.4728 17.1132 16.6632 15.9196C17.8536 14.7256 19.3167 14.1288 21.0528 14.1288C21.9456 14.1288 22.7477 14.2824 23.4586 14.5889C24.1695 14.8955 24.6571 15.1982 24.9216 15.4966L25.3186 15.9442V14.3526H27.997V26.8853Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M33.4875 23.4414C34.1902 24.1955 35.1199 24.5729 36.2772 24.5729C37.4844 24.5729 38.4516 24.2037 39.1793 23.4664C39.907 22.7286 40.2703 21.7464 40.2703 20.5196C40.2703 19.3097 39.8983 18.3274 39.1543 17.5728C38.4103 16.8187 37.4431 16.4418 36.2527 16.4418C35.0787 16.4418 34.1489 16.8187 33.4625 17.5728C32.7766 18.3274 32.4334 19.3097 32.4334 20.5196C32.4334 21.7132 32.7847 22.6873 33.4875 23.4414ZM42.8748 25.6172C42.8748 29.8447 40.7417 31.9579 36.4759 31.9579C35.7977 31.9579 35.1406 31.8838 34.5041 31.7341C33.8676 31.5849 33.3343 31.4112 32.9047 31.212C32.4747 31.0132 32.0945 30.8101 31.7638 30.6027C31.4331 30.3957 31.1854 30.2177 31.0198 30.0685L30.7966 29.8447L32.1358 27.8551L32.322 28.0418C32.3964 28.1164 32.5697 28.2531 32.8428 28.4519C33.1155 28.6511 33.4049 28.8292 33.7107 28.9866C34.0164 29.144 34.4091 29.285 34.8886 29.4091C35.3681 29.5338 35.8558 29.5959 36.3521 29.5959C37.7076 29.5959 38.6873 29.2931 39.2907 28.6882C39.8945 28.0832 40.1959 27.2088 40.1959 26.0648V24.9954C40.1628 25.0455 40.1134 25.1114 40.0471 25.1947C39.9809 25.2774 39.8239 25.4305 39.5763 25.6548C39.3281 25.8781 39.0593 26.073 38.7699 26.2385C38.4804 26.4046 38.0839 26.5538 37.5795 26.6866C37.0755 26.8189 36.5422 26.8854 35.9801 26.8854C34.1614 26.8854 32.6691 26.3386 31.5036 25.2442C30.3377 24.1503 29.755 22.5833 29.755 20.5442C29.755 18.6384 30.3502 17.0925 31.5406 15.9072C32.731 14.7218 34.1945 14.1289 35.9302 14.1289C36.823 14.1289 37.6251 14.2824 38.3359 14.589C39.0473 14.8955 39.535 15.1983 39.799 15.4966L40.1959 15.9442V14.3276H42.8748V25.6172Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M48.3855 23.5782C49.0883 24.3573 50.0185 24.7467 51.1758 24.7467C52.3993 24.7467 53.3703 24.3737 54.0899 23.6282C54.8089 22.8818 55.1684 21.8625 55.1684 20.5693C55.1684 19.3262 54.7964 18.3232 54.0529 17.5604C53.3084 16.7981 52.3412 16.4169 51.1508 16.4169C49.9767 16.4169 49.047 16.7981 48.3611 17.5604C47.6747 18.3232 47.3315 19.3262 47.3315 20.5693C47.3315 21.796 47.6828 22.799 48.3855 23.5782ZM57.7729 26.8604H55.0945V25.1447C55.0614 25.1943 55.0115 25.265 54.9457 25.356C54.8795 25.4474 54.7225 25.6005 54.4744 25.8161C54.2262 26.0317 53.9574 26.2223 53.668 26.3878C53.379 26.5539 52.982 26.7069 52.4776 26.8479C51.9736 26.9889 51.4403 27.0592 50.8782 27.0592C49.0595 27.0592 47.5672 26.5043 46.4017 25.3935C45.2358 24.2828 44.6531 22.6912 44.6531 20.6193C44.6531 18.663 45.2483 17.0883 46.4387 15.8947C47.6291 14.7012 49.0926 14.1039 50.8283 14.1039C51.7216 14.1039 52.5232 14.2575 53.2345 14.564C53.9454 14.8711 54.4331 15.1733 54.6976 15.4717L55.0945 15.9193V14.3277H57.7729V26.8604Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M66.1055 17.0134C64.9976 16.9137 64.1298 17.1837 63.5015 17.8214C62.8732 18.4596 62.5588 19.3345 62.5588 20.4448V26.8606H59.8804V14.3029H62.5588V16.5658C62.5756 16.4998 62.6125 16.4084 62.6706 16.2924C62.7282 16.1764 62.8607 15.969 63.0671 15.6706C63.274 15.3722 63.5053 15.1152 63.7616 14.8996C64.018 14.6845 64.3775 14.4896 64.8407 14.3154C65.3034 14.1416 65.7992 14.0709 66.3287 14.1041L66.1055 17.0134Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M67.2488 23.2797C67.6952 22.8485 68.2405 22.6334 68.8856 22.6334C69.5302 22.6334 70.076 22.8485 70.5224 23.2797C70.9688 23.7109 71.192 24.2413 71.192 24.8713C71.192 25.5012 70.9688 26.0316 70.5224 26.4628C70.076 26.8935 69.5302 27.1091 68.8856 27.1091C68.2405 27.1091 67.6952 26.8935 67.2488 26.4628C66.8024 26.0316 66.5792 25.5012 66.5792 24.8713C66.5792 24.2413 66.8024 23.7109 67.2488 23.2797Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M73.5848 14.0792H77.3548V15.7453C77.3874 15.6953 77.4292 15.6294 77.4786 15.5461C77.528 15.4633 77.648 15.3141 77.8381 15.099C78.0282 14.8834 78.2389 14.6923 78.4708 14.5268C78.7021 14.3607 79.016 14.2115 79.413 14.0792C79.81 13.9468 80.2314 13.8804 80.6778 13.8804C81.141 13.8804 81.5624 13.9425 81.9426 14.0667C82.3232 14.1908 82.6247 14.34 82.8479 14.5143C83.0711 14.6885 83.2568 14.8584 83.4056 15.0239C83.5549 15.19 83.6624 15.3392 83.7282 15.472L83.8026 15.6457C83.8357 15.5962 83.8813 15.5336 83.9389 15.4595C83.997 15.3844 84.1333 15.2439 84.3484 15.0364C84.5634 14.8295 84.7948 14.6471 85.0429 14.4897C85.2906 14.3319 85.6213 14.1908 86.0346 14.0667C86.4479 13.9425 86.878 13.8804 87.3244 13.8804C90.0032 13.8804 91.3424 15.4301 91.3424 18.5304V26.8607H87.5725V19.0276C87.5725 17.7181 87.093 17.0631 86.134 17.0631C84.9436 17.0631 84.3484 17.9337 84.3484 19.6739V26.8607H80.5784V19.0276C80.5784 17.7181 80.0989 17.0631 79.1404 17.0631C77.95 17.0631 77.3548 17.9337 77.3548 19.6739V26.8607H73.5848V14.0792Z",
        },
      }),
      _c("path", {
        attrs: {
          id: "pgm",
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M102.45 19.1271C102.433 19.0607 102.417 18.9823 102.4 18.8908C102.384 18.7999 102.314 18.6257 102.19 18.3687C102.066 18.1117 101.912 17.8879 101.731 17.6973C101.549 17.5067 101.284 17.3325 100.937 17.1751C100.59 17.0177 100.193 16.9388 99.7467 16.9388C99.3003 16.9388 98.9033 17.0134 98.5563 17.1626C98.2092 17.3118 97.9443 17.4942 97.7624 17.7098C97.5804 17.9254 97.4321 18.141 97.3164 18.3561C97.2003 18.5717 97.1345 18.7541 97.1177 18.9033L97.0683 19.1271H102.45ZM105.724 24.8715C105.674 24.9375 105.604 25.0203 105.513 25.1199C105.422 25.2195 105.207 25.3976 104.868 25.6546C104.529 25.9116 104.166 26.1392 103.777 26.3385C103.388 26.5372 102.871 26.7158 102.227 26.8731C101.582 27.0305 100.904 27.109 100.193 27.109C97.928 27.109 96.1798 26.5165 94.9476 25.3312C93.716 24.1458 93.1001 22.5172 93.1001 20.4448C93.1001 18.489 93.7284 16.8931 94.9851 15.6582C96.2412 14.4232 97.8291 13.8058 99.7467 13.8058C101.83 13.8058 103.463 14.4521 104.645 15.7453C105.827 17.0384 106.418 18.8206 106.418 21.0917V21.738H97.0433C97.0433 21.8044 97.0558 21.8872 97.0808 21.9868C97.1052 22.086 97.184 22.2602 97.3164 22.509C97.4484 22.7573 97.6179 22.9811 97.8248 23.1804C98.0312 23.3791 98.3456 23.5577 98.767 23.7151C99.1889 23.8724 99.6805 23.9509 100.243 23.9509C100.871 23.9509 101.475 23.831 102.053 23.5904C102.632 23.3503 103.053 23.1058 103.318 22.857L103.69 22.484L105.724 24.8715Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }